import { hospitals } from './hospitals.jsx';
import { coffee_shop } from './coffee_shop.jsx';
import { gyms } from './gyms.jsx';
import { lobbies } from './lobby.jsx';
import { salons } from './salons.jsx';
import { withDutchSolution } from './dutch.js';
import { withJapaneseSolution } from './japanese.js';

const baseSolutions = [hospitals, coffee_shop, gyms, lobbies, salons];

export const solutions = baseSolutions
  .map(withDutchSolution)
  .map(withJapaneseSolution)
  .sort((a, b) => b.id - a.id);

export const getSolutionBySlug = (slug) =>
  solutions.find(b => {
    if (typeof b.slug === 'string') return b.slug === slug;
    return Object.values(b.slug).includes(slug);
  });

export const getSolutionById = getSolutionBySlug;